import { render, staticRenderFns } from "./outbound-mail-message.vue?vue&type=template&id=626b027b&scoped=true"
import script from "./outbound-mail-message.vue?vue&type=script&lang=js"
export * from "./outbound-mail-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b027b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626b027b')) {
      api.createRecord('626b027b', component.options)
    } else {
      api.reload('626b027b', component.options)
    }
    module.hot.accept("./outbound-mail-message.vue?vue&type=template&id=626b027b&scoped=true", function () {
      api.rerender('626b027b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/messages/outbound-mail-message.vue"
export default component.exports